import React, {useEffect} from "react"
import {useNavigate, useParams} from "react-router-dom"
import './index.css';
import {
  IonContent,
  IonIcon,
  IonLabel,
  IonPage,
  IonTabBar,
  IonTabButton,
  IonRouterOutlet,
  IonTabs,
  IonHeader, IonToolbar, IonTitle, IonButton, IonButtons, IonCol, IonRow, IonItem, IonImg, IonFooter
} from "@ionic/react";
import styled from "@emotion/styled";
import axios from "axios";
import RegisterPage from "./RegisterPage";
import WelcomePage from "./WelcomePage";
import {getConfig} from "../../AppConfig";
import {Logo} from "../../components/Icons/Logo";
import useOgMeta from "../../hooks/useOgMeta";
import {Link} from "react-router-dom";


interface Params {
  eventcode: string
  id: string
  cart?: string
}

const HeaderWrapper = styled.div`
  flex-grow: 100;
  display: flex;
  border: 1px solid #66666660;
  justify-content: center;
`

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #66666660;
  height: 100px;
`;

const Store: React.FC = () => {
  const params = useParams();
  const eventcode = params.eventcode
  const eventtype = params.id
  const showCart = params.cart
  const { apiUrl } = getConfig()
  const domainName =  window.location.hostname
  const domainNames = domainName.split('.')
  const auctioncode = (domainNames && domainNames.length > 0) ? domainNames[0] : ''
  // const navigate = useNavigate()
  var [storeData, setStoreData] = React.useState({
    storewelcomeeventname: '',
    storewelcomeheader: '',
    storewelcomeeventlogourl: '',
    storewelcomebuttonevent: '',
    storewelcomebuttonauction: '',
    storewelcomebuttoneventshow: true,
    storewelcomebuttonauctionshow: true,
    torewelcomefooter: '',
    storewelcomeauctionlink: '',
    storelandinghtml: '',
    tabs: [],
    token: '',
    hascheckedout: false,
    hasMerch: false,
    status: '',
  })
  const [selectedTab, setSelectedTab] = React.useState('')
  const [register, setRegister] = React.useState(false)
  const [reloadData, setReloadData] = React.useState(false)
  const [internalReload, setInternalReload] = React.useState(1)
  const [errorMessage, setErrorMessage] = React.useState('')

  useEffect(() => {
    getStoreSetup()
  }, [reloadData])

  useEffect(() => {
    document.title = storeData?.storewelcomeeventname + ' - ' + 'EventSnap';
  }, [storeData]);

  useOgMeta(storeData?.storewelcomeeventname, storeData?.storewelcomeeventlogourl)

  const getStoreSetup = async () => {
    // setStoreData({
    //   storewelcomeeventname: '',
    //   storewelcomeheader: '',
    //   storewelcomeeventlogourl: '',
    //   storewelcomebuttonevent: '',
    //   storewelcomebuttonauction: '',
    //   storewelcomebuttoneventshow: false,
    //   storewelcomebuttonauctionshow: false,
    //   torewelcomefooter: '',
    //   storewelcomeauctionlink: '',
    //   storelandinghtml: '',
    //   tabs: [],
    //   token: '',
    //   hascheckedout: false,
    //   hasMerch: false,
    //   status: '',
    // })

    const body = {auctioncode: auctioncode, eventcode: eventcode}
    // const token = localStorage.getItem('tokenstore')

    // const headers = token  ? {'Authorization': `Bearer ${token}`} : {}
    let url = `${apiUrl}/storesetup1`
    const {data} = await axios.post(url, body, {})
    var parsedJson = JSON.parse(data?.jsonInfo)
    console.log(parsedJson)

    if (parsedJson?.status === 'failure') {
      setErrorMessage(parsedJson?.message || 'This event is not available.')
      return
    }

    parsedJson.hasMerch = false


    parsedJson?.tabs?.map(tab => {
      if (tab.tabname == 'Merchandise') {
          if (tab?.sections?.length > 0) {
              tab.sections.map(section => {
                  if (section?.data?.length > 0) {
                      const oneitme = section.data.find(item => item?.id > 0)
                      if (oneitme?.id > 0) {
                        parsedJson.hasMerch = true
                        tab.enabled = true
                      }
                      else {
                        tab.enabled = false
                      }
                  }
              })
          }
      }
    })
    if (parsedJson?.storelandinghtml?.length > 0) {
      parsedJson.storelandinghtml = JSON.parse(parsedJson?.storelandinghtml)
    }

    // setStoreData({...storeData, ...parsedJson})

    if (parsedJson.status === 'expired') {
      localStorage.removeItem("tokenstore")
      // history.push(`/${eventcode}/event`);
    }
// debugger;
    if (parsedJson && parsedJson.tabs) {
      if (parsedJson.hascheckedout) {
        setSelectedTab('Cart')
      }
      else {
        setSelectedTab(parsedJson.tabs[0].tabname)
      }
    }

    setStoreData({...parsedJson})
    setInternalReload(internalReload+1)
  }


  if (errorMessage) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'center', padding: '30px 0 20px' }}>
            <Logo width="350px" />
          </div>
          <div style={{ margin: '40px 20px', textAlign: 'center', fontSize: '22px', color: '#333' }}>
            {errorMessage}
          </div>
        </div>
        <div style={{ width: '75%', margin: 'auto', borderTop: '1px solid #666', paddingTop: '5px', paddingBottom: '20px', textAlign: 'center', color: '#666', fontSize: '12px' }}>
          EventSnap™. All Rights Reserved by DonorSnap.<br />
          <Link style={{ color: '#e53935', textDecoration: 'none' }} to={`/${eventcode}/privacy-policy`}>Privacy Policy</Link>
        </div>
      </div>
    )
  }

  if (eventtype === 'register') {
    return (
        <>
          <RegisterPage showCart={showCart} storeData={storeData} setStoreData={setStoreData} eventcode={eventcode} auctioncode={auctioncode} reloadData={reloadData} setReloadData={setReloadData} internalReload={internalReload} setInternalReload={setInternalReload}/>
        </>
    )
  }
  else {
    return (
        <>
          <WelcomePage storeData={storeData} eventcode={eventcode} auctioncode={auctioncode} />
        </>
    )
  }

}

export default Store
